/**
 * Extract HTML content of the element, including ShadowDOM.
 *
 * @param element If not provided, whole page content will be used.
 */
export const getInnerHTML = (element?: Element, tagsWithShadowRoots?: string[]): string => {
  element = element ?? document.documentElement;

  const shadowRootsParents = tagsWithShadowRoots
    ? Array.from(element.querySelectorAll(tagsWithShadowRoots.join(','))).filter(
        (el) => !!el.shadowRoot,
      )
    : [];

  const shadowRoots = shadowRootsParents.map((el) => el.shadowRoot);

  const safeGetHTML = (element: Element): string =>
    (element as any).getHTML?.({
      serializableShadowRoots: true, // this will work only for MFEs that allow serialization
      shadowRoots, // for MFEs that do not allow serialization
    }) ?? element.innerHTML; // fallback

  let html: string;

  // Compose full page HTML
  if (element === document.documentElement) {
    /* istanbul ignore next: Doctype is string only in jest virtual DOM environment */
    const doctype =
      typeof document.doctype === 'string'
        ? document.doctype
        : new XMLSerializer().serializeToString(document.doctype);

    html = `${doctype}
      <html>
        ${safeGetHTML(element)}
      </html>`;
  } else {
    html = safeGetHTML(element);
  }

  return html;
};

/**
 * Remove script and style tags from the HTML string.
 */
export const reduceHTML = (html: string): string => {
  return html
    .replace(/<script(.*?)>(.*?)<\/script>/gs, '')
    .replace(/<style(.*?)>(.*?)<\/style>/gs, '');
};
